export const NEW_CARD = 'new'
